/* eslint-disable @typescript-eslint/no-magic-numbers */
import { Vue, Component } from 'vue-property-decorator';
import { makeTracker } from '@/lib/tracker';
import { getJWT } from '@/lib/util';
const preAttribute = {
  // 预置属性
  userid_: (getJWT() && getJWT().id) || 0,
  url: window.location.href,
};
@Component
export default class Closure2TrackerMixin extends Vue {
  get isStrategy() {
    return (
      this.$route.query.From && this.$route.query.From.search('strategy') !== -1
    );
  }
  getLoadTime() {
    try {
      const timing = performance.timing;
      return Date.now() - timing.navigationStart;
    } catch (error) {
      return 0;
    }
  }
  closure2Tracker(event: string, trackers = {}) {
    const From = this.$route.query.From
    const FromSplit = From?.split('_')
    const act_version = FromSplit[0].substring(8, FromSplit[0].length)
    const tracker = makeTracker({
      tracking_scene: '中节点截流2',
      act_version,
      from: this.$route.query.From || '',
      from_version: this.$route.query.FromVersion || '',
      ...preAttribute,
    });
    tracker(event, trackers);
  }

  __closure2TrackerViewTracker() {
    const source_path = '0元弹窗';
    let timer: any = null;
    const timing = performance.timing;
    const runCheck = () => {
      // 既然调用load的时候loadEventEnd会为0
      // 那么就判断，如果值不为0,再收集性能指标
      if (performance.timing.loadEventEnd) {
        clearTimeout(timer);
        if (this.isStrategy) {
          this.closure2Tracker('landingpage_free_page_view', {
            Price: this.pageConfig.sensor_data.actual_price,
            source_path,
            load_duration: timing.loadEventEnd - timing.navigationStart, // ms
          });
        }
      } else {
        // 否则就定时调用runCheck方法，直到loadEventEnd不为0。
        timer = setTimeout(runCheck, 100);
      }
    };
    runCheck();
  }
  __closure2TrackerFreeClickTracker() {
    this.isStrategy &&
      this.closure2Tracker('landingpage_free_enroll_click', {
        Price: this.pageConfig.sensor_data.actual_price,
        button_name: '马上报名',
      });
  }
  __closure2TrackerFreeDoneTracker() {
    const source_path = '0元弹窗';
    this.isStrategy &&
      this.closure2Tracker('landingpage_enroll_done', {
        Price: this.pageConfig.sensor_data.actual_price,
        production_id: this.productionId,
        source_path,
      });
  }
}
